import { AlarmSeverityLevel } from '@repo/sdk/models/components';

export const AlarmSeverity = AlarmSeverityLevel;
export type AlarmSeverity = AlarmSeverityLevel;

/** All severities in display priority order (critical → warning → caution). */
export const ALL_ALARM_SEVERITIES = [
  AlarmSeverity.Critical,
  AlarmSeverity.Warning,
  AlarmSeverity.Caution,
] as const;
